/* Ofen 3 tooltip.
 *
 * On a pointer that hovers, the bubble opens on hover and on focus; click
 * still works and pins it. On touch there is no hover, so click is the only
 * way in. Detected with a media query rather than by sniffing the device,
 * because a laptop with a touchscreen has both.
 *
 * One open at a time, closed by Escape, by a click anywhere else, or by
 * clicking the same button again. Focus returns to the trigger, because the
 * bubble is opened deliberately and a keyboard user has to get back out.
 *
 * Placement is done here rather than in CSS: the bubble is position: fixed, so
 * it escapes the comparison grid's horizontal scroll container, which would
 * otherwise clip it on mobile. Below 768px the stylesheet turns it into a
 * bottom sheet and the horizontal maths is skipped.
 *
 * Delegated from the document, so tooltips rendered later by a section's own
 * JS work without re-initialising anything.
 */
(function () {
	if (window.__o3tInit) return;
	window.__o3tInit = true;

	var open = null;
	var pinned = false;
	/* Escape closes, then hands focus back to the trigger. That focus fires
	   focusin, which would open it again immediately. */
	var returningFocus = false;
	var canHover = window.matchMedia('(hover: hover) and (pointer: fine)');

	function pop(btn) {
		var wrap = btn.closest('.o3t');
		return wrap ? wrap.querySelector('[data-o3t-pop]') : null;
	}

	/* aria-expanded says a thing opened; without aria-controls it does not say
	   what, so a screen reader announces the state change and leaves the reader
	   to find the bubble. Paired here rather than in the Liquid because the
	   snippet renders inside loops with no id to be unique against, and because
	   tooltips built later by a section's own JS get linked the same way.

	   Run on load for what is already there, and again lazily in show() for
	   anything added since. */
	var uid = 0;
	function link(btn) {
		var p = pop(btn);
		if (!p) return null;
		if (!p.id) p.id = 'o3t-pop-' + (++uid);
		if (btn.getAttribute('aria-controls') !== p.id) btn.setAttribute('aria-controls', p.id);
		return p;
	}
	function linkAll(root) {
		(root || document).querySelectorAll('[data-o3t]').forEach(link);
	}
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', function () { linkAll(); });
	} else {
		linkAll();
	}
	document.addEventListener('shopify:section:load', function (e) { linkAll(e.target); });

	function close() {
		if (!open) return;
		var p = pop(open);
		if (p) p.hidden = true;
		open.setAttribute('aria-expanded', 'false');
		open = null;
		pinned = false;
	}

	function show(btn) {
		var p = link(btn);
		if (!p) return;
		if (open && open !== btn) close();
		p.hidden = false;
		btn.setAttribute('aria-expanded', 'true');
		open = btn;
		place(btn, p);
	}

	function place(btn, p) {
		/* The sheet layout owns both axes below 768px. */
		if (window.matchMedia('(max-width: 767px)').matches) return;

		var b = btn.getBoundingClientRect();
		var w = p.offsetWidth;
		var h = p.offsetHeight;
		var margin = 12;

		/* Centred on the button, then pulled back inside the viewport. */
		var left = b.left + b.width / 2 - w / 2;
		left = Math.max(margin, Math.min(left, window.innerWidth - w - margin));

		/* Below by default; above when there is not room, which is what happens
		   for a figure near the bottom of the fold. */
		var top = b.bottom + 8;
		if (top + h > window.innerHeight - margin) top = b.top - h - 8;

		p.style.left = left + 'px';
		p.style.top = Math.max(margin, top) + 'px';
	}

	document.addEventListener('click', function (ev) {
		var btn = ev.target.closest('[data-o3t]');

		if (!btn) {
			/* A click inside the bubble is not a click outside it. */
			if (open && !ev.target.closest('[data-o3t-pop]')) close();
			return;
		}

		var p = pop(btn);
		if (!p) return;

		/* A click on an already-hovered bubble pins it, so moving the mouse away
		   does not take it with you. A second click closes. */
		if (open === btn) {
			if (canHover.matches && !pinned) { pinned = true; return; }
			close();
			return;
		}

		show(btn);
		pinned = true;
	});

	/* Hover and focus open it unpinned, so it closes again on the way out. */
	document.addEventListener('mouseover', function (ev) {
		if (!canHover.matches) return;
		var btn = ev.target.closest('[data-o3t]');
		if (btn && open !== btn) { show(btn); pinned = false; }
	});

	document.addEventListener('mouseout', function (ev) {
		if (!canHover.matches || !open || pinned) return;
		var btn = ev.target.closest('[data-o3t]');
		if (!btn || btn !== open) return;
		/* Not if the pointer moved into the bubble itself. */
		var to = ev.relatedTarget;
		if (to && (to.closest('[data-o3t-pop]') || to.closest('[data-o3t]'))) return;
		close();
	});

	document.addEventListener('focusin', function (ev) {
		if (returningFocus) return;
		var btn = ev.target.closest('[data-o3t]');
		if (btn) { show(btn); pinned = false; }
	});

	document.addEventListener('keydown', function (ev) {
		if (ev.key !== 'Escape' || !open) return;
		var btn = open;
		close();
		returningFocus = true;
		btn.focus();
		returningFocus = false;
	});

	/* The bubble is fixed, so it does not travel with the button. Rather than
	   follow it on every frame, close it: the reader has scrolled away from the
	   figure it belongs to. */
	window.addEventListener('scroll', close, { passive: true });
	window.addEventListener('resize', close);
})();
